var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ForgotPasswordForm,{attrs:{"isSubmitting":_setup.isSubmitting},on:{"goto-login":_setup.navigateToLogin,"submit":_setup.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }